module.exports = __webpack_public_path__ + "static/img/11.fbb43e5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/2/eng/11.png
// module id = ZXqY
// module chunks = 0